<div
  class="slider-container"
  [attr.data-disabled]="isDisabled()"
  [attr.data-range]="range()"
  [style.height]="height()"
>
  @if (label()) {
    <label class="slider-label" [attr.for]="id">
      {{ label() }}
    </label>
  }

  <div class="slider-content">
    @if (!range()) {
      <!-- Single Value Slider -->
      <div class="slider-wrapper">
        <div class="slider-rail">
          <div class="slider-track">
            <!-- Filled track -->
            <div
              class="slider-track-fill"
              [style.height.%]="percentage()"
            ></div>
          </div>

          <div class="slider-marker" [style.bottom.%]="percentage()">
            <umss-marker></umss-marker>
          </div>
        </div>

        <!-- Hidden native input -->
        <input
          type="range"
          [id]="id"
          class="slider-input"
          [min]="min()"
          [max]="max()"
          [step]="step()"
          [value]="value()"
          [disabled]="isDisabled()"
          (input)="onSliderChange($event)"
          [attr.aria-label]="label() || 'Slider'"
          [attr.aria-valuemin]="min()"
          [attr.aria-valuemax]="max()"
          [attr.aria-valuenow]="value()"
        />
      </div>
    } @else {
      <!-- Range Slider -->
      <div class="slider-wrapper slider-wrapper-range">
        <div class="slider-rail">
          <div class="slider-track">
            <!-- Filled track (between start and end) -->
            <div
              class="slider-track-fill"
              [style.bottom.%]="rangeStartPercentage()"
              [style.height.%]="rangeEndPercentage() - rangeStartPercentage()"
            ></div>
          </div>

          <!-- Custom markers -->
          <div
            class="slider-marker slider-marker-start"
            [style.bottom.%]="rangeStartPercentage()"
          >
            <umss-marker></umss-marker>
          </div>
          <div
            class="slider-marker slider-marker-end"
            [style.bottom.%]="rangeEndPercentage()"
          >
            <umss-marker></umss-marker>
          </div>
        </div>

        <!-- Single range input -->
        <input
          type="range"
          [id]="id"
          class="slider-input slider-input-range"
          [min]="min()"
          [max]="max()"
          [step]="step()"
          [value]="rangeStart()"
          [disabled]="isDisabled()"
          (input)="onRangeInputChange($event)"
          (mousedown)="onRangeInputMouseDown()"
          (mouseup)="onRangeInputMouseUp()"
          (touchend)="onRangeInputMouseUp()"
          [attr.aria-label]="label() || 'Range slider'"
          [attr.aria-valuemin]="min()"
          [attr.aria-valuemax]="max()"
          [attr.aria-valuenow]="rangeStart() + ' to ' + rangeEnd()"
        />
      </div>
    }

    <!-- Marks display -->
    @if (marks().length > 0) {
      <div class="slider-marks">
        <div class="slider-marks-rail">
          @for (mark of marks(); track mark.value) {
            <span
              class="slider-mark-label pg-small-medium"
              [style.bottom.%]="getMarkPercentage(mark.value)"
            >
              {{ mark.label }}
            </span>
          }
        </div>
      </div>
    }

    @if (showValue()) {
      <div class="slider-value">
        @if (!range()) {
          <span>{{ value() }}</span>
        } @else {
          <span>{{ rangeStart() }} - {{ rangeEnd() }}</span>
        }
      </div>
    }
  </div>
</div>
